import styled from 'styled-components';
export const Container = styled.div`
  padding-top: 120px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  justify-content: center;
  background-color: #f2f2f2;
  font-family: 'Inter', sans-serif;
  @media (max-width: 600px) {
    padding-top: 117px;
  }
`;
export const InnerContainer = styled.div`
  width: 60%;
  padding: 50px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  margin: auto;
  border-radius: 10px;
  margin-bottom: 50px;
  @media (max-width: 600px) {
    padding: 10px;
    width: 100%;
    margin-bottom: 50px;
  }
`;
export const HeadingText = styled.div`
font-weight: 400;
font-size: 40px;
line-height: 1.5;
color: #202a36;
max-width: 884px;
@media (max-width: 600px) {
  font-size: 32px;
  line-height: 42px;
`;

export const SubHeading = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 1.5;
  margin: 10px 0;
  color: #202a36;
  max-width: 884px;
  @media (max-width: 600px) {
    font-size: 18px;
  }
`;

export const Text = styled.div`
  font-size: 18px;
  line-height: 27px;
  color: #676f79;
  margin-top: 14px;
  margin-bottom: 23px;
  max-width: 984px;
  @media (max-width: 600px) {
    margin-top: 10px;
    margin-bottom: 20px;
    line-height: 27px;
    font-size: 16px;
  }
`;
export const BulletPoint = styled.div`
  font-size: 18px;
  line-height: 27px;
  color: #676f79;
  margin-top: 5px;
  margin-bottom: 10px;
  max-width: 984px;
  margin-left: 25px;
  display: list-item;
  @media (max-width: 600px) {
    margin-top: 10px;
    line-height: 27px;
    margin-bottom: 20px;
    font-size: 16px;
  }
`;
export const InternalSubHeading = styled.div`
  font-weight: 500;
  font-size: 19px;
  line-height: 1.5;
  margin: 10px 0;
  color: #202a36;
  max-width: 884px;
  @media (max-width: 600px) {
    font-size: 18px;
  }
`;
